import classNames from 'classnames';
import styles from './index.module.scss';
import type { SwipperListItem } from '../../shared';
import { Key } from '@maxtropy/components';
import { isNil } from 'lodash-es';
import { MinusGreen, PlusRed, formatCompositeNumWithUnit, formatMediaNumWithUnit } from '../../utils';

interface Props {
  cardInfo: SwipperListItem;
  selectId?: Key;
  setSelectId: (id: Key) => void;
  setPhysicalUnitName: (v: string) => void;
  setIsMedium: (v: boolean) => void;
}

export function formatMomRatio(num?: number | null) {
  if (isNil(num)) return <span>--</span>;
  return num > 0 ? (
    <span style={{ color: PlusRed }}>+{num.toFixed(2)}%</span>
  ) : (
    <span style={{ color: MinusGreen }}>{num.toFixed(2)}%</span>
  );
}

const CardItem: React.FC<Props> = ({ selectId, cardInfo, setIsMedium, setSelectId, setPhysicalUnitName }) => {
  return (
    <div
      className={classNames(styles.cardItem, selectId === cardInfo.id ? styles.cardItemClicked : null)}
      onClick={() => {
        setSelectId(cardInfo.id);
        setPhysicalUnitName(cardInfo.physicalUnitName);
        setIsMedium(cardInfo.id !== 'total');
      }}
    >
      <div className={styles.firstLine}>
        <p className={styles.firstLine_left}>{cardInfo.name}</p>
        <p className={styles.firstLine_right}>环比{formatMomRatio(cardInfo.momRatio)}</p>
      </div>
      <p className={styles.secondLine}>
        {isNil(cardInfo.energyConsumption)
          ? '--'
          : cardInfo.id === 'total'
          ? formatCompositeNumWithUnit(cardInfo.energyConsumption)
          : formatMediaNumWithUnit(cardInfo.energyConsumption, cardInfo.physicalUnitName)}
      </p>
    </div>
  );
};

export default CardItem;
